<template>
  <div>
    <el-slider v-model="initValue" v-bind="{ ...item }" @change="handleChange" />
  </div>
</template>

<script>
import mixin from '../mixin'

export default {
  name: 'TSlider',
  mixins: [mixin],
  data() {
    return {}
  },
  methods: {
    handleChange(val) {
      this.changeValue = val
    }
  }
}
</script>

<style scoped></style>
